export class Country {
    constructor(isoCode, name) {
        this.isoCode = isoCode;
        this.name = name;
    }
    getIsoCode() {
        return this.isoCode;
    }
    getName() {
        return this.name;
    }
}
export const Countries = {
    AF: new Country('AF', 'Afghanistan'),
    AX: new Country('AX', '\u00c5land Islands'),
    AL: new Country('AL', 'Albania'),
    DZ: new Country('DZ', 'Algeria'),
    AS: new Country('AS', 'American Samoa'),
    AD: new Country('AD', 'Andorra'),
    AO: new Country('AO', 'Angola'),
    AI: new Country('AI', 'Anguilla'),
    AQ: new Country('AQ', 'Antarctica'),
    AG: new Country('AG', 'Antigua & Barbuda'),
    AR: new Country('AR', 'Argentina'),
    AM: new Country('AM', 'Armenia'),
    AW: new Country('AW', 'Aruba'),
    AC: new Country('AC', 'Ascension Island'),
    AU: new Country('AU', 'Australia'),
    AT: new Country('AT', 'Austria'),
    AZ: new Country('AZ', 'Azerbaijan'),
    BS: new Country('BS', 'Bahamas'),
    BH: new Country('BH', 'Bahrain'),
    BD: new Country('BD', 'Bangladesh'),
    BB: new Country('BB', 'Barbados'),
    BY: new Country('BY', 'Belarus'),
    BE: new Country('BE', 'Belgium'),
    BZ: new Country('BZ', 'Belize'),
    BJ: new Country('BJ', 'Benin'),
    BM: new Country('BM', 'Bermuda'),
    BT: new Country('BT', 'Bhutan'),
    BO: new Country('BO', 'Bolivia'),
    BA: new Country('BA', 'Bosnia & Herzegovina'),
    BW: new Country('BW', 'Botswana'),
    BR: new Country('BR', 'Brazil'),
    IO: new Country('IO', 'British Indian Ocean Territory'),
    VG: new Country('VG', 'British Virgin Islands'),
    BN: new Country('BN', 'Brunei'),
    BG: new Country('BG', 'Bulgaria'),
    BF: new Country('BF', 'Burkina Faso'),
    BI: new Country('BI', 'Burundi'),
    KH: new Country('KH', 'Cambodia'),
    CM: new Country('CM', 'Cameroon'),
    CA: new Country('CA', 'Canada'),
    IC: new Country('IC', 'Canary Islands'),
    CV: new Country('CV', 'Cape Verde'),
    BQ: new Country('BQ', 'Caribbean Netherlands'),
    KY: new Country('KY', 'Cayman Islands'),
    CF: new Country('CF', 'Central African Republic'),
    EA: new Country('EA', 'Ceuta & Melilla'),
    TD: new Country('TD', 'Chad'),
    CL: new Country('CL', 'Chile'),
    CN: new Country('CN', 'China'),
    CX: new Country('CX', 'Christmas Island'),
    CC: new Country('CC', 'Cocos (Keeling) Islands'),
    CO: new Country('CO', 'Colombia'),
    KM: new Country('KM', 'Comoros'),
    CG: new Country('CG', 'Congo - Brazzaville'),
    CD: new Country('CD', 'Congo - Kinshasa'),
    CK: new Country('CK', 'Cook Islands'),
    CR: new Country('CR', 'Costa Rica'),
    CI: new Country('CI', 'C\u00f4te d\u2019Ivoire'),
    HR: new Country('HR', 'Croatia'),
    CU: new Country('CU', 'Cuba'),
    CW: new Country('CW', 'Cura\u00e7ao'),
    CY: new Country('CY', 'Cyprus'),
    CZ: new Country('CZ', 'Czech Republic'),
    DK: new Country('DK', 'Denmark'),
    DG: new Country('DG', 'Diego Garcia'),
    DJ: new Country('DJ', 'Djibouti'),
    DM: new Country('DM', 'Dominica'),
    DO: new Country('DO', 'Dominican Republic'),
    EC: new Country('EC', 'Ecuador'),
    EG: new Country('EG', 'Egypt'),
    SV: new Country('SV', 'El Salvador'),
    GQ: new Country('GQ', 'Equatorial Guinea'),
    ER: new Country('ER', 'Eritrea'),
    EE: new Country('EE', 'Estonia'),
    ET: new Country('ET', 'Ethiopia'),
    FK: new Country('FK', 'Falkland Islands'),
    FO: new Country('FO', 'Faroe Islands'),
    FJ: new Country('FJ', 'Fiji'),
    FI: new Country('FI', 'Finland'),
    FR: new Country('FR', 'France'),
    GF: new Country('GF', 'French Guiana'),
    PF: new Country('PF', 'French Polynesia'),
    TF: new Country('TF', 'French Southern Territories'),
    GA: new Country('GA', 'Gabon'),
    GM: new Country('GM', 'Gambia'),
    GE: new Country('GE', 'Georgia'),
    DE: new Country('DE', 'Germany'),
    GH: new Country('GH', 'Ghana'),
    GI: new Country('GI', 'Gibraltar'),
    GR: new Country('GR', 'Greece'),
    GL: new Country('GL', 'Greenland'),
    GD: new Country('GD', 'Grenada'),
    GP: new Country('GP', 'Guadeloupe'),
    GU: new Country('GU', 'Guam'),
    GT: new Country('GT', 'Guatemala'),
    GG: new Country('GG', 'Guernsey'),
    GN: new Country('GN', 'Guinea'),
    GW: new Country('GW', 'Guinea-Bissau'),
    GY: new Country('GY', 'Guyana'),
    HT: new Country('HT', 'Haiti'),
    HN: new Country('HN', 'Honduras'),
    HK: new Country('HK', 'Hong Kong SAR China'),
    HU: new Country('HU', 'Hungary'),
    IS: new Country('IS', 'Iceland'),
    IN: new Country('IN', 'India'),
    ID: new Country('ID', 'Indonesia'),
    IR: new Country('IR', 'Iran'),
    IQ: new Country('IQ', 'Iraq'),
    IE: new Country('IE', 'Ireland'),
    IM: new Country('IM', 'Isle of Man'),
    IL: new Country('IL', 'Israel'),
    IT: new Country('IT', 'Italy'),
    JM: new Country('JM', 'Jamaica'),
    JP: new Country('JP', 'Japan'),
    JE: new Country('JE', 'Jersey'),
    JO: new Country('JO', 'Jordan'),
    KZ: new Country('KZ', 'Kazakhstan'),
    KE: new Country('KE', 'Kenya'),
    KI: new Country('KI', 'Kiribati'),
    XK: new Country('XK', 'Kosovo'),
    KW: new Country('KW', 'Kuwait'),
    KG: new Country('KG', 'Kyrgyzstan'),
    LA: new Country('LA', 'Laos'),
    LV: new Country('LV', 'Latvia'),
    LB: new Country('LB', 'Lebanon'),
    LS: new Country('LS', 'Lesotho'),
    LR: new Country('LR', 'Liberia'),
    LY: new Country('LY', 'Libya'),
    LI: new Country('LI', 'Liechtenstein'),
    LT: new Country('LT', 'Lithuania'),
    LU: new Country('LU', 'Luxembourg'),
    MO: new Country('MO', 'Macau SAR China'),
    MK: new Country('MK', 'Macedonia'),
    MG: new Country('MG', 'Madagascar'),
    MW: new Country('MW', 'Malawi'),
    MY: new Country('MY', 'Malaysia'),
    MV: new Country('MV', 'Maldives'),
    ML: new Country('ML', 'Mali'),
    MT: new Country('MT', 'Malta'),
    MH: new Country('MH', 'Marshall Islands'),
    MQ: new Country('MQ', 'Martinique'),
    MR: new Country('MR', 'Mauritania'),
    MU: new Country('MU', 'Mauritius'),
    YT: new Country('YT', 'Mayotte'),
    MX: new Country('MX', 'Mexico'),
    FM: new Country('FM', 'Micronesia'),
    MD: new Country('MD', 'Moldova'),
    MC: new Country('MC', 'Monaco'),
    MN: new Country('MN', 'Mongolia'),
    ME: new Country('ME', 'Montenegro'),
    MS: new Country('MS', 'Montserrat'),
    MA: new Country('MA', 'Morocco'),
    MZ: new Country('MZ', 'Mozambique'),
    MM: new Country('MM', 'Myanmar (Burma)'),
    NA: new Country('NA', 'Namibia'),
    NR: new Country('NR', 'Nauru'),
    NP: new Country('NP', 'Nepal'),
    NL: new Country('NL', 'Netherlands'),
    NC: new Country('NC', 'New Caledonia'),
    NZ: new Country('NZ', 'New Zealand'),
    NI: new Country('NI', 'Nicaragua'),
    NE: new Country('NE', 'Niger'),
    NG: new Country('NG', 'Nigeria'),
    NU: new Country('NU', 'Niue'),
    NF: new Country('NF', 'Norfolk Island'),
    KP: new Country('KP', 'North Korea'),
    MP: new Country('MP', 'Northern Mariana Islands'),
    NO: new Country('NO', 'Norway'),
    OM: new Country('OM', 'Oman'),
    PK: new Country('PK', 'Pakistan'),
    PW: new Country('PW', 'Palau'),
    PS: new Country('PS', 'Palestinian Territories'),
    PA: new Country('PA', 'Panama'),
    PG: new Country('PG', 'Papua New Guinea'),
    PY: new Country('PY', 'Paraguay'),
    PE: new Country('PE', 'Peru'),
    PH: new Country('PH', 'Philippines'),
    PN: new Country('PN', 'Pitcairn Islands'),
    PL: new Country('PL', 'Poland'),
    PT: new Country('PT', 'Portugal'),
    PR: new Country('PR', 'Puerto Rico'),
    QA: new Country('QA', 'Qatar'),
    RE: new Country('RE', 'R\u00e9union'),
    RO: new Country('RO', 'Romania'),
    RU: new Country('RU', 'Russia'),
    RW: new Country('RW', 'Rwanda'),
    WS: new Country('WS', 'Samoa'),
    SM: new Country('SM', 'San Marino'),
    ST: new Country('ST', 'S\u00e3o Tom\u00e9 & Pr\u00edncipe'),
    SA: new Country('SA', 'Saudi Arabia'),
    SN: new Country('SN', 'Senegal'),
    RS: new Country('RS', 'Serbia'),
    SC: new Country('SC', 'Seychelles'),
    SL: new Country('SL', 'Sierra Leone'),
    SG: new Country('SG', 'Singapore'),
    SX: new Country('SX', 'Sint Maarten'),
    SK: new Country('SK', 'Slovakia'),
    SI: new Country('SI', 'Slovenia'),
    SB: new Country('SB', 'Solomon Islands'),
    SO: new Country('SO', 'Somalia'),
    ZA: new Country('ZA', 'South Africa'),
    GS: new Country('GS', 'South Georgia & South Sandwich Islands'),
    KR: new Country('KR', 'South Korea'),
    SS: new Country('SS', 'South Sudan'),
    ES: new Country('ES', 'Spain'),
    LK: new Country('LK', 'Sri Lanka'),
    BL: new Country('BL', 'St. Barth\u00e9lemy'),
    SH: new Country('SH', 'St. Helena'),
    KN: new Country('KN', 'St. Kitts & Nevis'),
    LC: new Country('LC', 'St. Lucia'),
    MF: new Country('MF', 'St. Martin'),
    PM: new Country('PM', 'St. Pierre & Miquelon'),
    VC: new Country('VC', 'St. Vincent & Grenadines'),
    SD: new Country('SD', 'Sudan'),
    SR: new Country('SR', 'Suriname'),
    SJ: new Country('SJ', 'Svalbard & Jan Mayen'),
    SZ: new Country('SZ', 'Swaziland'),
    SE: new Country('SE', 'Sweden'),
    CH: new Country('CH', 'Switzerland'),
    SY: new Country('SY', 'Syria'),
    TW: new Country('TW', 'Taiwan'),
    TJ: new Country('TJ', 'Tajikistan'),
    TZ: new Country('TZ', 'Tanzania'),
    TH: new Country('TH', 'Thailand'),
    TL: new Country('TL', 'Timor-Leste'),
    TG: new Country('TG', 'Togo'),
    TK: new Country('TK', 'Tokelau'),
    TO: new Country('TO', 'Tonga'),
    TT: new Country('TT', 'Trinidad & Tobago'),
    TA: new Country('TA', 'Tristan da Cunha'),
    TN: new Country('TN', 'Tunisia'),
    TR: new Country('TR', 'Turkey'),
    TM: new Country('TM', 'Turkmenistan'),
    TC: new Country('TC', 'Turks & Caicos Islands'),
    TV: new Country('TV', 'Tuvalu'),
    UM: new Country('UM', 'U.S. Outlying Islands'),
    VI: new Country('VI', 'U.S. Virgin Islands'),
    UG: new Country('UG', 'Uganda'),
    UA: new Country('UA', 'Ukraine'),
    AE: new Country('AE', 'United Arab Emirates'),
    GB: new Country('GB', 'United Kingdom'),
    US: new Country('US', 'United States'),
    UY: new Country('UY', 'Uruguay'),
    UZ: new Country('UZ', 'Uzbekistan'),
    VU: new Country('VU', 'Vanuatu'),
    VA: new Country('VA', 'Vatican City'),
    VE: new Country('VE', 'Venezuela'),
    VN: new Country('VN', 'Vietnam'),
    WF: new Country('WF', 'Wallis & Futuna'),
    EH: new Country('EH', 'Western Sahara'),
    YE: new Country('YE', 'Yemen'),
    ZM: new Country('ZM', 'Zambia'),
    ZW: new Country('ZW', 'Zimbabwe'),
};
//# sourceMappingURL=countries.js.map